<template>
	<li class="manage-list-row clearfix">
		<div class="vendor-widget">
			<div class="job-info">
				<div class="job-details">
					<h3 class="c-name"><a class="job_name_tag">{{ vendor.name }} - {{ vendor.officialName }}</a></h3>
					<small class="c-employee"><i class="fa fa-user"></i>{{ vendor.contactPerson }}</small>
					<small class="c-place"><i class="fa fa-phone"></i>{{ vendor.phoneNumber }}</small>
					<small class="c-est"><i class="fa fa-file-text"></i>{{ $t('vendor.title2') }}: {{ vendor.contract.length }}</small>
					<small class="c-est"><i class="fa fa-cc"></i>{{ $t('vendor.title3') }}: {{ vendor.invoice.length }}</small>
					<div><el-tag class="vendor-category">{{ getVendorCategory(vendor.category) }}</el-tag></div>
				</div>
			</div>
			<div class="job-buttons">
				<el-button type="primary" icon="el-icon-edit" circle @click="editVendor"></el-button>
			</div>
		</div>
	</li>
</template>
<style scoped>
	.job-buttons {
		visibility: hidden
	}
	.manage-list-row:hover .job-buttons {
		visibility: visible
	}
	.vendor-category {
		min-width: 100px;
		text-align: center
	}
</style>
<script>
export default {
  name: 'VendorWidget',
  props: ['vendor'],
  data: function() {
    return {
    }
  },
  methods: {
    editVendor: function() {
      this.$router.push({ path: '/vendor/edit/' + this.vendor.id })
    }
  },
  created: function() {
    
  }
}
</script>